import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutoAwesomeMosaicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"auto_awesome_mosaic"}/>
}
